import React from 'react';
import { useWorkshops } from '../WorkshopContext';
import { Link } from 'react-router-dom';
import styles from './ListComponent.module.css';

const ListComponent = ({ workshops }) => {  
  const { state, dispatch } = useWorkshops();
  const items = typeof workshops !== 'undefined' ? workshops : state.workshops;

  const toggleSelection = (workshopId) => {
    const isSelected = state.selectedWorkshops.includes(workshopId);
    dispatch({ 
      type: isSelected ? 'deselect_workshop' : 'select_workshop',
      payload: workshopId 
    });
  };

  const handleWorkshopClick = (workshopId) => {
    dispatch({ type: 'set_selected', payload: workshopId });
  };

  const handleCheckboxChange = (isChecked, workshop) => {        
    if (process.env.NODE_ENV === "development")  {
      console.log(`${workshop.name} is ${isChecked ? 'selected' : 'unselected'}`);
      console.log(workshop);
    }
    
    console.log(state.selectedWorkshops.length)
    toggleSelection(workshop.id);
    handleWorkshopClick(workshop.id)
       
  };

  const isCompareEnabled = function() {    
    return state.selectedWorkshops.length > 1 && state.selectedWorkshops.length < 6;
  }

  return (    
    <div className="panel">
      <div id="ws-list">
        {items.map((workshop) => (          
          <a
            key={workshop.id}
            className={`panel-block workshop-item ${state.selectedWorkshopId === workshop.id ? styles.clickedWorkshop : ''}`}
            data-workshop={workshop.id}
            onClick={() => handleWorkshopClick(workshop.id)}
            title={`${workshop.name}${(Array.isArray(workshop.land_uses) && workshop.land_uses.length) ? ` (${workshop.land_uses.join(', ')})` : ''}`}
          >
          <span className='has-text-weight-light'>{`${workshop.id}.`} &nbsp;</span>
          <span className='has-text-weight-normal'>{`${workshop.name}`} &nbsp;</span>
          <span className='has-text-weight-light is-size-7'>{`(${workshop.country_code})`}</span>
          <input
            type="checkbox"
            className="workshop-checkbox ml-2"
            checked={state.selectedWorkshops.includes(workshop.id)}
            onChange={(e) => handleCheckboxChange(e.target.checked, workshop)}            
            disabled={state.selectedWorkshops.length >= 5 && !state.selectedWorkshops.includes(workshop.id)}
          />
        </a>
        ))}
      </div>
      <div className="panel-block is-block">                
        <Link className={`button is-link is-fullwidth ${isCompareEnabled() ? styles.compareButton : styles.compareButtonDisabled}`} to={`/compare/${state.selectedWorkshops.join(',')}`}>Compare</Link>
        {!isCompareEnabled() && (
          <p className="has-text-grey is-size-7 has-text-centered mt-2">
            Select at least 2 workshops to enable comparison
          </p>
        )}
      </div>
  </div>
  );
};

export default ListComponent;
